import { CommonModule } from '@angular/common';
import {
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-businesscase',
  templateUrl: './businesscase.component.html',
  styleUrls: ['./businesscase.component.css'],
  imports: [TranslateModule, CommonModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class BusinesscaseComponent {
  @Input() isMobileView = false;
  @Output() shareAdviceLink = new EventEmitter<void>();
  @Output() requestContact = new EventEmitter<void>();
}
